import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ShiftSummary } from 'src/app/core/interfaces/shift-summery';
import {
  getShiftSummaryRowNetValue,
  getShiftSummaryRowReturnValue,
  getShiftSummaryRowSaleValue,
  SHIFT_SUMMARY_ROWS,
  ShiftSummaryRowDef
} from 'src/app/core/utils/shift-summary-row.util';

@Component({
  selector: 'app-print-shift-summary',
  templateUrl: './print-shift-summary.component.html',
  styleUrls: ['./print-shift-summary.component.scss']
})
export class PrintShiftSummaryComponent {
  @Input() shiftSummary: ShiftSummary | null = null;
  @Input() closingNotes: string = '';
  @Input() actualCashAmount: number = 0;
  @Input() actualCardAmount: number = 0;

  @ViewChild('printArea', { static: false }) printArea!: ElementRef<HTMLDivElement>;

  rows: ShiftSummaryRowDef[] = SHIFT_SUMMARY_ROWS;

  getRowSaleValue(row: ShiftSummaryRowDef): number {
    return this.shiftSummary ? getShiftSummaryRowSaleValue(this.shiftSummary, row) : 0;
  }

  getRowReturnValue(row: ShiftSummaryRowDef): number | null {
    return this.shiftSummary ? getShiftSummaryRowReturnValue(this.shiftSummary, row) : null;
  }

  getRowNetValue(row: ShiftSummaryRowDef): number {
    return this.shiftSummary ? getShiftSummaryRowNetValue(this.shiftSummary, row) : 0;
  }

  get requiredDiff(): number {
    if (!this.shiftSummary) return 0;
    return this.actualCashAmount - this.shiftSummary.totalCash;
  }

  get budgetDiff(): number {
    if (!this.shiftSummary) return 0;
    return this.actualCardAmount - this.shiftSummary.totalCreditCard;
  }

  print(): void {
    if (!this.printArea) return;

    const printContent = this.printArea.nativeElement.innerHTML;
    const headHtml = document.head.innerHTML;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (!doc) return;

    doc.open();
    doc.write(`
        <html dir="rtl" lang="ar">
            <head>
                <title>طباعة ملخص الوردية</title>
                ${headHtml}
                <style>
                    /* Force A4 rules natively on the iframe */
                    @page {
                        size: auto !important;
                        margin: 0 !important;
                    }
                    body {
                        background: white !important;
                        padding: 0 !important;
                        margin: 0 !important;
                        direction: rtl;
                    }
                    .print-isolated-container {
                        width: 100% !important;
                        padding: 10mm !important;
                        box-sizing: border-box !important;
                        background: white !important;
                    }
                </style>
            </head>
            <body onload="setTimeout(function() { window.print(); }, 500)">
                <div class="print-isolated-container">
                    ${printContent}
                </div>
            </body>
        </html>
    `);
    doc.close();

    // Cleanup iframe after print
    setTimeout(() => {
        if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
        }
    }, 15000);
  }
}
